// import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useCreateField } from "../../hooks/createField.hook";

import styled, { css } from "styled-components";

import Cell from "../cell/Cell";

import cursor from '../../assets/target.png';
import grid from '../../assets/grid.png';

const StyledField = styled.div`
    display: grid;
    width: 332px;
    height: 332px;
    margin: ${props => props.owner === 'computer' ? '30px 30px 30px 0': '30px 0 30px 30px'};
    border-radius: 5px;
    box-shadow: inset 6px 6px 10px 0 rgba(0, 0, 0, 0.2),
        inset -6px -6px 10px 0 rgba(255, 255, 255, 0.5);
    grid-template-columns: repeat(10, 33px);
    background: url('${grid}') repeat;

    ${props => props.owner === 'computer' ? css`
        cursor: url('${cursor}') 32 32, auto;
            ` : css`pointer-events: none;`
    }
`;

const Field = (props) => {

    const { humanShot, humanMark } = props;
    // const { createField, addShips } = props;
    const owner = props.owner;

    // const dispatch = useDispatch();
    const field = useSelector(state => owner === 'player' ? state.player.field : state.computer.field)

    // const { generatedField, allShips } = useCreateField(owner === 'computer' ? owner : undefined);

    // useEffect(() => {
    //     if (owner === 'computer') {
    //         dispatch(createField(generatedField));
    //         dispatch(addShips(allShips));
    //     }
    //     // eslint-disable-next-line
    // }, []);

    const renderField = arr => {
        
        return arr.map(({id, ...props}) => {
            return (
                <Cell key={id} id={id} fieldOwner={owner} {...props} />
            );
        });
    }

    const cells = renderField(field);

    return (
        <StyledField owner={owner} onClick={e => humanShot(e)} onContextMenu={e => humanMark(e)}>
            {cells}
        </StyledField>
    );
}

export default Field;